export default __webpack_public_path__ + "static/media/empty-library.825eb794.png";